import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppLayerModule } from './shared/components/app-layer/app-layer.module';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, AppLayerModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {
    title = 'front';
}
